import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "axios";

export var reportListRes;
export const reportListTodo = createAsyncThunk('reportList', async (val) => {
    let user_id = JSON.parse(localStorage.getItem('user_data'))
    try {
        const res = await axios({

            method: "post",
            url: process.env.REACT_APP_API_URL + 'report/view_report_list',
            data: {
                "user_id": user_id.vemp_code,
                "user_role": user_id.vrole_name,
                "device_token": user_id.vdevice_token
            },
            headers: { "Content-Type": "application/json", "Authorization": 'Bearer ' + user_id.access_token }
        })
        return reportListRes = res.data
    } catch (error) {
        return reportListRes = error.response.data
    }
})


const reportListSlice = createSlice({
    name: 'reportList',
    initialState: {
        data: null,
    },
    extraReducers: (builder) => {
        builder.addCase(reportListTodo.fulfilled, (state, action) => {
            if (action.payload.success) {
                state.data = action.payload;
                // console.log('reportList', state.data)
            }
        });
        builder.addCase(reportListTodo.rejected, (state, action) => {
            // console.log('token_error', action)
        })
    }
});

export default reportListSlice.reducer; 